var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.34658L10.3863 7.34631V5.07517C10.3863 2.87475 8.5 1.69246 6.92478 1.69246C4.16011 1.69246 3.23657 5.07517 3.5 7.34631H1.5C1.5 2.84631 4.12102 0 6.92478 0C9.72855 0 12 2.27141 12 5.07517V7.34658Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2892 18H2.20356C1.2808 18 0 16.7193 0 15.7966V9C0 8.07724 0.712945 6.8485 1.6357 6.8485L11.7373 6.8485C12.6601 6.8485 13.5 7.49175 13.5 8.41451V16C13.5 16.9583 12.2119 18 11.2892 18ZM2.20356 8.41451C1.88414 8.41451 1.6357 8.66295 1.6357 8.98236V15.7966C1.6357 16.116 1.88414 16.3644 2.20356 16.3644H11.2892C11.6086 16.3644 11.857 16.116 11.857 15.7966V8.98236C11.857 8.66295 11.6086 8.41451 11.2892 8.41451H2.20356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77141 11.1358C7.77141 11.7747 7.27454 12.2715 6.6357 12.2715C5.99687 12.2715 5.5 11.7747 5.5 11.1358C5.5 10.497 5.99687 10.0001 6.6357 10.0001C7.27454 10.0001 7.77141 10.5325 7.77141 11.1358Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6357 11.0001H7.06785L6.5 14.4072H8.20356L7.6357 11.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ac3093628ed890da4e2a5fe81e8a057c.svg";
export { ForwardRef as ReactComponent };